export default __webpack_public_path__ + "static/media/choose.89776c69.jpg";